import PropTypes from 'prop-types';
import { useState, useLayoutEffect, useMemo, useCallback } from 'react';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJImageUploadWidthHistory from '../../../../common/combineComponents/FJImageUploadWidthHistory/FJImageUploadWidthHistory.jsx';
import FJTitleLine from '../../../../common/combineComponents/FJTitleLine/FJTitleLine.jsx';
import { IMAGE_UPLOAD_MODES } from '../../../../config/dataConfig/FJAIVideoGeneratorData.js';
import {
    UPLOAD_FILE_TO_VIDEO,
    CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
    CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_VIDEOS,
} from '../../../../config/dataConfig/FJGenerateData.js';
import FJAIImageListContainer from '../../../../common/combineComponents/FJAIImageListContainer/container/FJAIImageListContainer.jsx';
import FJSwitchButton from '../../../../common/components/FJSwitchButton/FJSwitchButton.jsx';
import FJExchangeIcon from '../../../../assets/svg/exchange.svg?react';
import FJToolTip from '../../../../common/components/FJToolTip/FJToolTip.jsx';

import styles from './FJAIVideoMultiModeImageUploader.module.less';
import FJUtil from '../../../../util/FJUtil.js';
import useAIListSideModelData from '../../../../hooks/useAIListSideModelData.jsx';
import FJImageUpload from '../../../../common/components/FJUpload/FJImageUpload/FJImageUpload.jsx';
import FJVideoUpload from '../../../../common/components/FJUpload/FJVideoUpload/FJVideoUpload.jsx';

import FJPersonUpload from '../../../../assets/svg/aiGeneratorVideo/person-upload.svg?react';
import FJPersonIcon from '../../../../assets/svg/aiGeneratorVideo/person.svg?react';
import FJVideoIcon from '../../../../assets/svg/aiGeneratorVideo/video.svg?react';
import FJVideoUploadIcon from '../../../../assets/svg/aiGeneratorVideo/video-upload.svg?react';

const FJAIVideoMultiModeImageUploader = ({
    imageMode,
    onImageModeChange,
    // 单图模式
    originImage,
    uploadStatus,
    uploadFile,
    onFileDelete,
    // 首尾帧模式
    startImage,
    endImage,
    onStartImageUpload,
    onEndImageUpload,
    onStartImageDelete,
    onEndImageDelete,
    startUploadStatus,
    endUploadStatus,
    // 多图模式
    multiImages,
    onMultiImageUpload,
    onMultiImageDelete,
    multiUploadStatuses,
    // 公共props
    isDraggingFile,
    setIsDraggingFile,
    openMediaLibrary,
    showAIImageHistoryList,
    onExchangeStartEndImage,
    // 特殊模式
    isMotionControl,
    motionControlImage,
    motionControlVideo,
    maxMotionVideoDuration,
    onUploadMotionControlImage,
    onUploadMotionControlVideo,
    onDeleteMotionControlImage,
    onDeleteMotionControlVideo,
}) => {
    const { isShow } = useAIListSideModelData();

    // 添加响应式位置状态
    const [imageListPosition, setImageListPosition] = useState({ top: 71, left: 559 });
    const [targetIndex, setTargetIndex] = useState(0);

    // 监听屏幕大小变化 调整 AI image list 位置
    useLayoutEffect(() => {
        const updatePosition = () => {
            if (FJUtil.isAiVideoGeneratorLandingPage()) {
                const appBoxDom = document.getElementById('app-box');
                if (appBoxDom) {
                    const rect = appBoxDom.getBoundingClientRect();
                    const position = {
                        top: rect.top + window.pageYOffset,
                        left: rect.left + 478,
                    };
                    setImageListPosition(position);
                }
            } else {
                // const isLargeScreen = window.innerWidth > 1441;
                // setImageListPosition({
                //     top: 71,
                //     left: isLargeScreen ? 727 : 551,
                // });
            }
        };

        updatePosition();
        window.addEventListener('resize', updatePosition);

        return () => {
            window.removeEventListener('resize', updatePosition);
        };
    }, [isShow]);

    const isStartEndModeEnabled = useMemo(() => {
        return imageMode === IMAGE_UPLOAD_MODES.START_END;
    }, [imageMode]);

    const multiImagesWithStatus = useMemo(() => {
        return multiImages.map((image, index) => ({
            ...image,
            uploadStatus: multiUploadStatuses[index] || 'default',
        }));
    }, [multiImages, multiUploadStatuses]);

    const handleShowAIImageHistoryList = useCallback(
        index => {
            showAIImageHistoryList();
            setTargetIndex(index);
        },
        [showAIImageHistoryList],
    );
    const renderUploadContent = () => {
        if (isMotionControl) {
            return (
                <div className={styles.start_end_container}>
                    <div className={styles.start_end_box}>
                        <div className={styles.image_upload_item}>
                            <FJImageUpload
                                imageInfo={motionControlImage}
                                isDelete={true}
                                isDraggingFile={isDraggingFile}
                                acceptFile={UPLOAD_FILE_TO_VIDEO + CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES}
                                onDelete={onDeleteMotionControlImage}
                                openMediaLibrary={openMediaLibrary}
                                setIsDraggingFile={setIsDraggingFile}
                                uploadImg={onUploadMotionControlImage}
                                style={{ height: 154, width: 204 }}
                                uploadTitle={FJLocalStore._('upload-reference-image')}
                                uploadText={FJLocalStore._('clear-image-of-the-face-and-body')}
                                leftBottomIcon={<FJPersonIcon />}
                                uploadTextClassName={styles.upload_motion_control_text}
                                defaultIcon={<FJPersonUpload />}
                                previewClassName={styles.preview_image}
                            />
                        </div>
                        <div className={styles.image_upload_item}>
                            <FJVideoUpload
                                defaultIcon={<FJVideoUploadIcon />}
                                acceptFile={CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_VIDEOS}
                                uploadTextClassName={styles.upload_motion_control_text}
                                leftBottomIcon={<FJVideoIcon />}
                                uploadTitle={FJLocalStore._('upload-reference-video')}
                                uploadText={FJLocalStore._('supported-3-xxx-secs').replace(
                                    'xxx',
                                    maxMotionVideoDuration,
                                )}
                                style={{ height: 154, width: 204 }}
                                uploadFile={file => {
                                    onUploadMotionControlVideo(file);
                                }}
                                onDelete={onDeleteMotionControlVideo}
                                openMediaLibrary={() => {
                                    openMediaLibrary(0, 'VIDEO', CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_VIDEOS);
                                }}
                                mediaInfo={motionControlVideo}
                                previewVideoStyle={{ left: '559px', top: '80px' }}
                            />
                        </div>
                    </div>
                </div>
            );
        } else if (imageMode === IMAGE_UPLOAD_MODES.MULTI) {
            return (
                <div className={styles.multi_container}>
                    <div className={styles.multi_grid}>
                        {multiImagesWithStatus.map((image, index) => {
                            return (
                                <div key={index} className={styles.multi_upload_item}>
                                    <FJImageUploadWidthHistory
                                        isOptional={index !== 0}
                                        openMediaLibrary={() => {
                                            openMediaLibrary(index);
                                        }}
                                        originImage={image}
                                        uploadImg={file => onMultiImageUpload(file, index)}
                                        uploadStatus={image.uploadStatus}
                                        isDraggingFile={isDraggingFile}
                                        setIsDraggingFile={setIsDraggingFile}
                                        showAIImageHistoryList={() => handleShowAIImageHistoryList(index)}
                                        onDelete={() => onMultiImageDelete(index)}
                                        fileType={UPLOAD_FILE_TO_VIDEO + CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES}
                                        style={{ marginTop: 0 }}
                                        previewImageStyle={{ left: '559px' }}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </div>
            );
        } else if (imageMode === IMAGE_UPLOAD_MODES.START_END && isStartEndModeEnabled) {
            return (
                <div className={styles.start_end_container}>
                    <div className={styles.start_end_box}>
                        <div className={styles.image_upload_item}>
                            <FJImageUploadWidthHistory
                                openMediaLibrary={() => {
                                    openMediaLibrary(0);
                                }}
                                originImage={startImage}
                                uploadImg={file => onStartImageUpload(file, 0)}
                                uploadStatus={startUploadStatus}
                                isDraggingFile={isDraggingFile}
                                setIsDraggingFile={setIsDraggingFile}
                                showAIImageHistoryList={() => handleShowAIImageHistoryList(0)}
                                onDelete={onStartImageDelete}
                                fileType={UPLOAD_FILE_TO_VIDEO + CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES}
                                style={{ marginTop: 0 }}
                                text={FJLocalStore._('upload-start-frame')}
                                previewImageStyle={{ left: '559px' }}
                                label={<div className={styles.label}>{FJLocalStore._('start-frame')}</div>}
                            />
                        </div>
                        <div className={styles.image_upload_item}>
                            <FJImageUploadWidthHistory
                                openMediaLibrary={() => {
                                    openMediaLibrary(1);
                                }}
                                originImage={endImage}
                                uploadImg={file => onEndImageUpload(file, 1)}
                                uploadStatus={endUploadStatus}
                                isDraggingFile={isDraggingFile}
                                setIsDraggingFile={setIsDraggingFile}
                                showAIImageHistoryList={() => handleShowAIImageHistoryList(1)}
                                onDelete={onEndImageDelete}
                                fileType={UPLOAD_FILE_TO_VIDEO + CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES}
                                style={{ marginTop: 0 }}
                                text={FJLocalStore._('upload-end-frame')}
                                label={<div className={styles.label}>{FJLocalStore._('end-frame')}</div>}
                                previewImageStyle={{ left: '559px' }}
                                isOptional
                            />
                        </div>
                    </div>
                    <FJToolTip title={FJLocalStore._('swap')}>
                        <div className={styles.exchange_button} onClick={onExchangeStartEndImage}>
                            <FJExchangeIcon />
                        </div>
                    </FJToolTip>
                </div>
            );
        } else {
            return (
                <div className={styles.single_container}>
                    <FJImageUploadWidthHistory
                        isSmallComponent
                        openMediaLibrary={() => {
                            openMediaLibrary(0);
                        }}
                        originImage={originImage}
                        uploadImg={uploadFile}
                        uploadStatus={uploadStatus}
                        isDraggingFile={isDraggingFile}
                        setIsDraggingFile={setIsDraggingFile}
                        showAIImageHistoryList={() => handleShowAIImageHistoryList(0)}
                        onDelete={onFileDelete}
                        fileType={UPLOAD_FILE_TO_VIDEO + CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES}
                        style={{ marginTop: 0 }}
                        previewImageStyle={{ left: '559px' }}
                    />
                </div>
            );
        }
    };
    return (
        <div className={styles.multi_mode_uploader}>
            <FJTitleLine
                title={FJLocalStore._('upload')}
                isShowTry={false}
                isShowHelp={false}
                style={{ marginTop: '21px', marginBottom: '8px' }}
                isRequire
                renderRight={() =>
                    imageMode !== IMAGE_UPLOAD_MODES.MULTI &&
                    !isMotionControl && (
                        <div className={styles.switch_button_box}>
                            {FJLocalStore._('enable-end-frame')}
                            <FJSwitchButton
                                active={isStartEndModeEnabled}
                                onChange={() => {
                                    onImageModeChange(
                                        isStartEndModeEnabled
                                            ? IMAGE_UPLOAD_MODES.SINGLE
                                            : IMAGE_UPLOAD_MODES.START_END,
                                    );
                                }}
                                style={{ marginLeft: '8px' }}
                                tooltip={isStartEndModeEnabled ? FJLocalStore._('turn-off') : FJLocalStore._('turn-on')}
                            />
                        </div>
                    )
                }
            />

            <div className={styles.upload_content}>{renderUploadContent()}</div>

            <FJAIImageListContainer
                position={imageListPosition}
                targetIndex={targetIndex}
                absolutePosition={FJUtil.isAiVideoGeneratorLandingPage()}
            />
        </div>
    );
};

FJAIVideoMultiModeImageUploader.propTypes = {
    // 模式相关
    imageMode: PropTypes.string.isRequired,
    onImageModeChange: PropTypes.func.isRequired,

    // 单图模式
    originImage: PropTypes.object,
    uploadStatus: PropTypes.string,
    uploadFile: PropTypes.func,
    onFileDelete: PropTypes.func,

    // 首尾帧模式
    startImage: PropTypes.object,
    endImage: PropTypes.object,
    onStartImageUpload: PropTypes.func,
    onEndImageUpload: PropTypes.func,
    onStartImageDelete: PropTypes.func,
    onEndImageDelete: PropTypes.func,
    startUploadStatus: PropTypes.string,
    endUploadStatus: PropTypes.string,
    onExchangeStartEndImage: PropTypes.func,

    // 多图模式
    multiImages: PropTypes.array,
    onMultiImageUpload: PropTypes.func,
    onMultiImageDelete: PropTypes.func,
    multiUploadStatuses: PropTypes.array,

    // 公共props
    isDraggingFile: PropTypes.bool,
    setIsDraggingFile: PropTypes.func,
    openMediaLibrary: PropTypes.func,
    showAIImageHistoryList: PropTypes.func,
    // 特殊模式
    isMotionControl: PropTypes.bool,
    motionControlImage: PropTypes.object,
    motionControlVideo: PropTypes.object,
    onUploadMotionControlImage: PropTypes.func,
    onDeleteMotionControlVideo: PropTypes.func,
    onUploadMotionControlVideo: PropTypes.func,
    onDeleteMotionControlImage: PropTypes.func,
    maxMotionVideoDuration: PropTypes.number,
};

export default FJAIVideoMultiModeImageUploader;
